import { BrowserRouter,Routes,Route } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Companies from "./pages/Companies";
import Contacts from "./pages/Contacts";
import Meetings from "./pages/Meetings";
import Users from "./pages/Users";
import CalendarPage from "./pages/CalendarPage";
import Timeline from "./pages/Timeline";
import MeetingsNotes from "./pages/MeetingsNotes";

import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import ReminderPage from "./pages/Reminderpage";
import Followup from "./pages/Followup";

export default function App(){

 return(

 <BrowserRouter>

 <Routes>

 <Route path="/" element={<Login/>} />

 <Route
 element={
  <ProtectedRoute>
   <Layout/>
  </ProtectedRoute>
 }
 >

 <Route path="/dashboard" element={<Dashboard/>}/>
 <Route path="/companies" element={<Companies/>}/>
 <Route path="/contacts" element={<Contacts/>}/>
 <Route path="/meetings" element={<Meetings/>}/>
 <Route path="/meetingsNotes" element={<MeetingsNotes/>}/>
 <Route path="/calendar" element={<CalendarPage/>}/>
 <Route path="/timeline" element={<Timeline/>}/>
 <Route path="/users" element={<Users/>}/>
 <Route path="/reminder" element={<ReminderPage/>}/>
  <Route path="/followup" element={<Followup/>}/>
 </Route>

 </Routes>

 </BrowserRouter>

 );

}